import { Directive, Input, TemplateRef } from '@angular/core';

export type TTemplate = 'content' | 'header' | 'footer' | '';

// to expand see more use cases --> https://github.com/primefaces/primeng/blob/master/src/app/components/card/card.ts
@Directive({
  selector: '[cvTemplate]',
  standalone: true,
})
export class TemplateDirective {
  @Input() cvTemplate: TTemplate = '';

  constructor(public templateRef: TemplateRef<never>) {}

  getType(): TTemplate {
    return this.cvTemplate;
  }
}
